// compareSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { toast } from "react-toastify";
// const compareSlice = createSlice({
//   name: 'compare',
//   initialState: {
//     compareItems: [],
//   },
//   reducers: {
//     addToCompare: (state, action) => {
//       const itemExists = state.compareItems.some(item => item.id === action.payload.id);
//       if (!itemExists) {
//         state.compareItems.push(action.payload);
//         toast.success(`Compare Added Successfully: ${action.payload.name}!`);
//       }
//       else {
//         toast.warn(`Product ${action.payload.name} is already in the comparison list.`);
//       }
//     },
//     removeFromCompare: (state, action) => {
//       state.compareItems = state.compareItems.filter(item => item.id !== action.payload);
//       toast.info('Product removed from comparison list.');
//     },
//     clearCompare: (state) => {
//       state.compareItems = [];
//       toast.info('Comparison list cleared.');
//     },
//   },
// });


const compareSlice = createSlice({
  name: 'compare',
  initialState: {
    compareItems: []
  },
  reducers: {
    addToCompare: (state, action) => {
      const itemExists = state.compareItems.some(item => item.id === action.payload.id);
         if (!itemExists) {
         state.compareItems.push(action.payload);
        toast.success(`Compare Added Successfully: ${action.payload.name}!`);
       }
    },
    clearCompare: (state) => {
      state.compareItems = [];
      toast.info('Comparison list cleared.');
    },
    removeFromCompare: (state, action) => {
      state.compareItems = state.compareItems.filter(item => item.id !== action.payload);
     toast.info('Product removed from comparison list.');
    }
  }
});

export const { addToCompare, removeFromCompare, clearCompare } = compareSlice.actions;
export default compareSlice.reducer;
